<template>
  <div>
    <el-button type="primary" @click="dialogVisible = true">添加受控探头</el-button>
    <el-input
      placeholder="根据 ssid 进行搜索"
      prefix-icon="el-icon-search"
      :clearable="true"
      v-model="searchSSID"
      style="width: 18%"
      @input="getData">
    </el-input>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="ssid"
        label="SSID"
        width="180">
      </el-table-column>
      <el-table-column
        prop="expirationTime"
        label="过期时间"
        width="180">
      </el-table-column>
      <el-table-column
        prop="address"
        label="操作">
        <template slot-scope="scope">
          <el-button type="primary" @click="updateProbeRent(scope.row)">更新过期时间</el-button>
          <el-button type="danger" @click="delProbeRent(scope.row)">删除租赁探头</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="提交表单"
      :visible.sync="dialogVisible"
      width="30%">
      <el-input
        maxlength="18" minlength="17"
        v-model="addProbeRentSSID" placeholder="请输入探头SSID"></el-input>
      <br />
      <br />
      <el-date-picker
        v-model="addProbeRentDate"
        type="date"
        placeholder="选择日期">
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addProbeRent">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择更新时间"
      :visible.sync="updateDialogVisible"
      width="30%">
      <el-date-picker
        v-model="updateProbeRentDate"
        type="date"
        placeholder="选择日期">
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmUpdateProbeRent">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Global from "../Global";

export default {
  name: "ProbeRent",
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      addProbeRentSSID: '',
      addProbeRentDate: '',
      updateDialogVisible: false,
      updateProbeRentDate: '',
      updateProbeRentSSID: '',
      searchSSID: ''
    }
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    async getData() {
      let resp = await this.axios(
        {
          method: 'GET',
          url: Global.accountUrl + '/probeRent/getProbeRentInfoList',
          params: {
            ssid: this.searchSSID === '' ? null : this.searchSSID
          }
        }
      )
      this.tableData = resp.data.data
    },
    async addProbeRent() {
      let resp = await this.axios(
        {
          method: 'POST',
          url: Global.accountUrl + '/probeRent/addProbeRentInfo',
          data: {
            'ssid': this.addProbeRentSSID,
            'expirationTime': this.addProbeRentDate
          }
        }
      )
      if (resp.data.code === 200) {
        this.$message(
          {
            type: 'success',
            message: '添加受控探头成功'
          }
        )
      } else {
        this.$message(
          {
            type: 'info',
            message: '添加受控探头失败'
          }
        )
      }
      this.getData()
      this.dialogVisible = false
    },
    updateProbeRent(row) {
      this.updateDialogVisible = true
      this.updateProbeRentSSID = row.ssid
    },
    delProbeRent(row) {
      this.$confirm(
        '此操作将删除当前探头租赁信息，是否继续？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios({
            method: 'post',
            url: Global.accountUrl + '/probeRent/delProbeRentInfo',
            params: {
              ssid: row.ssid
            }
          }).then(resp => {
            if (resp.data.code === 200) {
              this.$message({
                type: 'success',
                message: '已取消删除'
              })
              this.getData()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    async confirmUpdateProbeRent() {
      let resp = await this.axios({
        method: 'POST',
        url: Global.accountUrl + '/probeRent/updateProbeRentInfo',
        data: {
          ssid: this.updateProbeRentSSID,
          expirationTime: this.updateProbeRentDate
        }
      })
      if (resp.data.code === 200) {
        this.$message(
          {
            type: 'success',
            message: '更新受控探头成功'
          }
        )
      } else {
        this.$message(
          {
            type: 'info',
            message: '更新受控探头失败'
          }
        )
      }
      this.getData()
      this.updateDialogVisible = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/proberent/ProbeRent.vue